import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { RootState } from '../../../types/rootState'
import { useIntl, defineMessages } from 'react-intl'
import {
  Card,
  Image,
  CardBody,
  Heading,
  ComponentTrackingType,
  CardProps
} from '@homebotapp/hb-react-component-catalog'
import AdImage from '../../../assets/homes/img/16x9-mobile-app-estimate-value.png'
import { selectNativeAccessFeature } from '../../../store/selectors/customerProfile'
import { QrCodeWithAppStoreLinks } from '../NativeAppQrCodeModal/QrCodeWithAppStoreLinks/QrCodeWithAppStoreLinks'

export const MSG = defineMessages({
  h3: {
    id: 'DigestNativeAppAdModule.h3',
    defaultMessage: 'New Mobile App'
  },
  h2: {
    id: 'DigestNativeAppAdModule.h2',
    defaultMessage: 'Be the smartest on your block'
  },
  alt: {
    id: 'DigestNativeAppAdModule.alt',
    defaultMessage: 'New Homebot Mobile App'
  }
})

export interface NativeAppFixedSidebarAdProps extends CardProps {
  tracking: ComponentTrackingType
}

export const DigestNativeAppAdModule = ({ tracking, ...cardProps }: NativeAppFixedSidebarAdProps) => {
  const intl = useIntl()

  return (
    <Card {...cardProps} size='lg' scrollMarginTop='var(--digest-module-scroll-margin-top)'>
      <Image src={AdImage} alt={intl.formatMessage(MSG.alt)} borderTopRadius='md' width='100%' objectFit='cover' />
      <CardBody paddingX={4} paddingY={6}>
        <Heading as='h3' size='2xs' color='brand' textAlign='left' marginBottom={0} variant='eyebrow'>
          {intl.formatMessage(MSG.h3)}
        </Heading>
        <Heading size='md' textAlign='left'>
          {intl.formatMessage(MSG.h2)}
        </Heading>
        <QrCodeWithAppStoreLinks tracking={tracking} hideQrCode={true} />
      </CardBody>
    </Card>
  )
}
